// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1qEgP","box":"WorkspacesBox_box__1pR3i","node":"WorkspacesBox_node__3vQ73"};